import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import { useTranslation } from "react-i18next";

import SecretForm from "../../Forms/SecretForms/SecretForm";
import NotifyUserForm from "../../Forms/NotifyUserForms/NotifyUserForm";

const NotifyUserModal = (props) => {
  const { update } = props;

  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:notifyuser.basicInformation"), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "NotifyUserForm";
  const { handleHide, show } = props;

  const buttons = () => {
    return (
      <>
        <BMXButton
          data-cy="save"
          type="submit"
          onClick={() => setIsSubmit(true)}
          bmxclass="Success"
          form={formName}
        >
          {t("global:save")}
        </BMXButton>
      </>
    );
  };

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      height={"650px"}
      width={"880px"}
      onClose={handleHide}
      header={props.header}
      buttons={buttons()}
      steps={steps}
    >
      <NotifyUserForm
        steps={steps}
        isSubmit={isSubmit}
        step={step}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "NotifyUserModal" })(NotifyUserModal);
